import { useEnquiryModal } from '@/hooks/useEnquiryModal';
import { currentSeasonalProduct } from '@/mocks/seasonalProducts';
import FeaturedProductCard from '@/components/feature/FeaturedProductCard';
import FadeInSection from '@/components/base/FadeInSection';

export default function SeasonalPicks() {
  const { openEnquiry } = useEnquiryModal();

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10 max-w-7xl mx-auto">
        {/* Section Header */}
        <FadeInSection>
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-accent-100 text-accent-800 text-xs font-semibold rounded-full mb-4">
              <i className="ri-sun-line text-sm"></i>
              In Season Now
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
              Seasonal Fresh Picks Spotlight
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
              Premium seasonal produce currently in high demand
            </p>
          </div>
        </FadeInSection>

        {/* Featured Product Spotlight */}
        <FadeInSection delay={150}>
          <FeaturedProductCard
            product={currentSeasonalProduct}
            variant="spotlight"
            onEnquire={openEnquiry}
          />
        </FadeInSection>
      </div>
    </section>
  );
}